import React from "react";
import Seo, { breadcrumbSchema } from "../components/Seo";
import { LegalShell, H2, P, UL } from "./PrivacyPolicy";
import { SITE } from "../data/mock";

export default function AccessibilityStatement() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "Accessibility Statement", path: "/accessibility-statement" },
  ];
  return (
    <>
      <Seo
        title="Accessibility Statement | Boston Iron Grit"
        description="Boston Iron Grit's commitment to digital and physical accessibility — WCAG 2.1 AA goals for this website and accessible facilities in West Roxbury."
        path="/accessibility-statement"
        schemas={[breadcrumbSchema(crumbs)]}
      />
      <LegalShell title="Accessibility Statement" updated="August 12, 2026" crumbName="Accessibility Statement" path="/accessibility-statement">
        <div>
          <H2>Our commitment</H2>
          <P>
            Boston Iron Grit is committed to making our website and our gym accessible to everyone, including people with disabilities.
            Fitness is for every body — that belief extends to how we build our digital and physical spaces.
          </P>
        </div>
        <div>
          <H2>This website</H2>
          <P>We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA. Measures we take include:</P>
          <UL
            items={[
              "Semantic HTML with a logical heading structure on every page.",
              "Text alternatives for meaningful images and labels on all form fields.",
              "Sufficient color contrast between text and backgrounds.",
              "Full keyboard operability for navigation, menus and forms.",
              "Reduced-motion friendly animations and no content that flashes.",
            ]}
          />
        </div>
        <div>
          <H2>The gym</H2>
          <P>
            Our facility at {SITE.address.full} offers free on-site parking with the entrance on Sambuca Way Alley, ground-level access to
            the training floor, and coaches trained to scale every workout to individual abilities, including adaptive needs. If you have a
            question about physical access before your first visit, call or text {SITE.phone} and we will make it work.
          </P>
        </div>
        <div>
          <H2>Feedback</H2>
          <P>
            If you experience any difficulty accessing part of this website, or have suggestions to improve accessibility, please email
            {" "}{SITE.email} or call {SITE.phone}. We take reports seriously and will address issues promptly.
          </P>
        </div>
      </LegalShell>
    </>
  );
}
